import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlaygroundHistoryRoute = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("mask", {
			id: "wrench-halo",
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 0,
				y: 0,
				width: 24,
				height: 24,
				fill: "white"
			}), /* @__PURE__ */ _jsx("g", {
				transform: "translate(10, 10) scale(0.6)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.106-3.105c.32-.322.863-.22.983.218a6 6 0 0 1-8.259 7.057l-7.91 7.91a1 1 0 0 1-2.999-3l7.91-7.91a6 6 0 0 1 7.057-8.259c.438.12.54.662.219.984z",
					fill: "black",
					stroke: "black",
					strokeWidth: 6
				})
			})]
		}) }),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#wrench-halo)",
			children: [
				/* @__PURE__ */ _jsx("path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" }),
				/* @__PURE__ */ _jsx("path", { d: "M3 3v5h5" }),
				/* @__PURE__ */ _jsx("path", { d: "M12 7v5l4 2" })
			]
		}),
		/* @__PURE__ */ _jsx("g", {
			transform: "translate(10, 10) scale(0.6)",
			children: /* @__PURE__ */ _jsx("path", { d: "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.106-3.105c.32-.322.863-.22.983.218a6 6 0 0 1-8.259 7.057l-7.91 7.91a1 1 0 0 1-2.999-3l7.91-7.91a6 6 0 0 1 7.057-8.259c.438.12.54.662.219.984z" })
		})
	]
});
export default SvgPlaygroundHistoryRoute;
